/**
 * Quickview product
 */

class ProductQuickview extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showQuickview.bind(this));
		this.addEventListener('keypress', this.keyPress.bind(this));
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.showQuickview(e);
		}
	}

	showQuickview(e) {
		e.preventDefault();

		const productUrl = this.getAttribute('data-product-url');
		const modalQuickview = document.getElementById('tpt-quickview-modal');
		const modalQuickviewContainer = document.getElementById('tpt-quickview-modal__ajax-data');
		const modalQuickviewLoading = document.getElementById('tpt-quickview-modal__loading');

		modalQuickviewLoading.classList.remove('hidden');

		modalQuickviewContainer.innerHTML = '';

		document.getElementsByTagName('html')[0].classList.add('open-modal');
		modalQuickview.classList.add('show');

		modalQuickview._triggerElement = e.currentTarget;

		fetch(productUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				const quickviewData = responseHTML.querySelector('.shopify-section').innerHTML;

				modalQuickviewContainer.innerHTML = quickviewData;

				/**
				 * Re-render javascript tags
				 */
				modalQuickview.querySelectorAll('script').forEach((oldScriptTag) => {
					const newScriptTag = document.createElement('script');
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});
			})
			.finally(() => {
				modalQuickviewLoading.classList.add('hidden');

				const focusElement = modalQuickview.querySelector('[data-close="modal"]');
				trapFocus(modalQuickview, focusElement);
			});
	}
}

customElements.define('tpt-quickview', ProductQuickview);

/**
 * Variant selects quickview
 */

class TptQuickviewVariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange(event) {
		this.updateOptions();
		this.updateMasterId();
		this.updateSelectedSwatchValue(event);
		this.toggleAddButton(true, '', false);
		this.removeErrorMessage();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();

			//this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
			if (element.tagName === 'SELECT') {
				return element.value;
			}
			if (element.tagName === 'FIELDSET') {
				return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
			}
		});
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateSelectedSwatchValue({ target }) {
		const { name, value, tagName } = target;

		if (tagName === 'SELECT' && target.selectedOptions.length) {
			const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
			const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
			if (!selectedDropdownSwatchValue) return;
			if (swatchValue) {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
				selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
			} else {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
				selectedDropdownSwatchValue.classList.add('swatch--unavailable');
			}
		} else if (tagName === 'INPUT' && target.type === 'radio') {
			const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
			if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
		}
	}

	updateMedia() {}

	updateVariantInput() {
		console.log(this.currentVariant.id);

		const inputIdForm = document.querySelectorAll('#tpt-quickview-modal input[name="id"]');
		inputIdForm.forEach((input) => {
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
		const inputWrappers = [...this.querySelectorAll('.product-form__input')];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(elementList, availableValuesList) {
		elementList.forEach((element) => {
			const value = element.getAttribute('value');
			const availableElement = availableValuesList.includes(value);

			if (element.tagName === 'INPUT') {
				element.classList.toggle('disabled', !availableElement);
			} else if (element.tagName === 'OPTION') {
				element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace('[value]', value);
			}
		});
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

		fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, 'text/html');

				/**
				 * Update product media gallery
				 */
				if (this.closest('.shopify-section')) {
					const gallaryProductContainer = this.closest('.shopify-section').querySelector('.tpt-product-media-gallery');

					if (gallaryProductContainer) {
						const mediaProductGallery = html.getElementById('ProductMediaGallery').innerHTML;

						gallaryProductContainer.innerHTML = mediaProductGallery;
					}
				}

				/**
				 * Update product variant id
				 */

				const inputIdForm = document.querySelectorAll('#tpt-quickview-modal input[name="id"]');
				inputIdForm.forEach((input) => {
					input.value = this.currentVariant.id;
					input.dispatchEvent(new Event('change', { bubbles: true }));
				});

				/**
				 * Update element id
				 */
				const elementUpdate = ['tpt-quickview-modal__info-price', 'tpt-quickview-modal__info-quantity', 'tpt-quickview-modal__gallery'];

				elementUpdate.forEach((element) => {
					if (html.getElementById(element)) {
						const elementHtml = html.getElementById(element).innerHTML;
						document.getElementById(element).innerHTML = elementHtml;
					}
				});

				/**
				 * End update element id
				 */

				var addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

				this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant,
					},
				});
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		var productForm = document.getElementById(`product-form-${this.dataset.section}`);

		if (this.closest('.quickview-modal')) {
			productForm = document.getElementById(`product-form-tpt-quickview-${this.dataset.section}`);
		}

		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('tpt-quickview-variant-selects', TptQuickviewVariantSelects);

/**
 * Gallery slider
 */

class TptQuickViewGallery extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.tpt-quickview__gallery-main .swiper');
		const mainNext = this.querySelector('.tpt-quickview__gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.tpt-quickview__gallery-main .swiper-button-prev');

		const thumbSwiper = this.querySelector('.tpt-quickview__gallery-thumb .swiper');
		const thumbNext = this.querySelector('.tpt-quickview__gallery-thumb .swiper-button-next');
		const thumbPrev = this.querySelector('.tpt-quickview__gallery-thumb .swiper-button-prev');

		var swiperThumb = new Swiper(thumbSwiper, {
			spaceBetween: 8,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: thumbNext,
				prevEl: thumbPrev,
			},
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 5,
				},
				768: {
					slidesPerView: 5,
				},
			},
		});

		var swiperMain = new Swiper(mainSwiper, {
			slidesPerView: 1,
			spaceBetween: 10,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: mainNext,
				prevEl: mainPrev,
			},
			keyboard: {
				enabled: true,
			},
			thumbs: {
				swiper: swiperThumb,
			},
		});

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-quickview-gallery', TptQuickViewGallery);
